var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, ChangeDetectorRef } from '@angular/core';
import { ModalService } from '@ibe/services/ui';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { DomSanitizer } from '@angular/platform-browser';
import { INDRAIbeAdminConfigService } from "@ibe.services/ibeadmin-config.service";
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import { takeWhile } from 'rxjs/operators';
import { SESSION_VAR_KEY_CURRENCY, SESSION_VAR_KEY_LANGUAGE, SESSION_VAR_KEY_LASTNAME, SESSION_VAR_KEY_MARKET, SESSION_VAR_KEY_SESSION, SESSION_VAR_KEY_USER_DATA } from '@ibe.config';
import { INDRASessionTimeoutModalComponent } from '../session-timeout-modal/session-timeout-modal.indra.component';
import { Router } from '@angular/router';
import { INDRAObservatoryService } from '@ibe.services/observatory.indra.service';
var INDRAPaymentAdyenModalComponent = /** @class */ (function (_super) {
    __extends(INDRAPaymentAdyenModalComponent, _super);
    function INDRAPaymentAdyenModalComponent(cdr, modalService, sanitizer, store, ibeAdminConfigService, router, observatory) {
        var _this = _super.call(this, modalService) || this;
        _this.cdr = cdr;
        _this.modalService = modalService;
        _this.sanitizer = sanitizer;
        _this.store = store;
        _this.ibeAdminConfigService = ibeAdminConfigService;
        _this.router = router;
        _this.observatory = observatory;
        _this.isAlive = true;
        _this.url = "";
        _this.showLoading = false;
        _this.errMsg = "";
        _this.hasPaymentMethodRestrictions = false;
        _this.removedPaymentMethodRestrictions = false;
        _this.booking_trip$ = _this.store.select(fromStore.getSelectedBookedTrip);
        _this.extras$ = _this.store.select(fromStore.getSelectedBookedTripExtras);
        _this.extras = [];
        _this.hasPartnerHotelExtra = false;
        _this.recover_insurance$ = _this.store.select(fromStore.getSelectedBookedTripRecoverInsurance);
        _this.userInfo$ = _this.store.select(fromStore.getUserInfo);
        _this.userInfo = null;
        _this.bookAwardFlights$ = _this.store.select(fromStore.getFlightsFilterBookAwardFlights);
        _this.okToDelete$ = _this.store.select(fromStore.getConfirmModalConfirm);
        _this.okToDelete = '';
        _this.isMobile$ = _this.store.select(fromStore.isScreenMobile);
        _this.isMobile = false;
        _this.loaded = false;
        _this.TYPE = 'payment';
        _this.bookAwardFlights$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.bookAwardFlights = value;
            _this.updateData({ bookAwardFlights: _this.bookAwardFlights });
        });
        return _this;
    }
    INDRAPaymentAdyenModalComponent.prototype.onMessage = function (event) {
        if (event && event.data && event.data === 'sessionTimeoutModal') {
            this.modalService.close();
            this.modalService.assignComponent(INDRASessionTimeoutModalComponent);
            this.modalService.open();
        }
        else if (event && event.data && event.data.redirect) {
            if (event.data.queryParams) {
                this.router.navigate([event.data.redirect, event.data.pnr, event.data.lastname], { queryParams: event.data.queryParams });
            }
            if (event.data.pnr) {
                this.router.navigate([event.data.redirect, event.data.pnr, event.data.lastname]);
            }
            else {
                this.router.navigate([event.data.redirect]);
            }
        }
        else if (event && event.data && event.data.queryParams) {
            switch (event.data.queryParams) {
                case 'viewPurchaseSuccess':
                    this.router.navigate(['/my-bookings/view', event.data.pnr, event.data.lastname]);
                    break;
                case 'issueAuthorisedOK':
                case 'issueAuthorisedKO':
                    this.observatory.setData(event.data.queryParams, true);
                    this.router.navigate(['/my-bookings/view', event.data.pnr, event.data.lastname]);
                    break;
                case 'viewPurchaseError':
                    this.router.navigate(['/my-bookings/view', event.data.pnr, event.data.lastname], { queryParams: { issue: 'PURCHASE_ERROR' } });
                    break;
                case 'viewPurchasePending':
                    this.router.navigate(['/my-bookings/view', event.data.pnr, event.data.lastname], { queryParams: { issue: 'PENDING' } });
                    break;
                default:
                    break;
            }
        }
    };
    INDRAPaymentAdyenModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        var urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue('externalURLs.AdyenPaymentUrl');
        this.showLoading = true;
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(urlIbeAdmin);
        this.booking_trip$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (trip) {
            if (trip) {
                _this.booking_trip = trip;
                if (trip.insurance) {
                    _this.hasPaymentMethodRestrictions = true;
                }
                else {
                    _this.hasPaymentMethodRestrictions = false;
                }
                _this.updateData({ hasPaymentMethodRestrictions: _this.hasPaymentMethodRestrictions });
            }
        });
        this.extras$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.extras = value;
                var hotels = _this.extras.find(function (extra) { return extra.type === 'hotel'; });
                _this.hasPartnerHotelExtra = (hotels && hotels.data && hotels.data.length > 0) ? true : false;
            }
            else {
                _this.hasPartnerHotelExtra = false;
            }
            _this.updateData({ hasPartnerHotelExtra: _this.hasPartnerHotelExtra });
        });
        this.recover_insurance$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (insurance) {
            if (insurance && insurance.length) {
                _this.recover_insurance = insurance;
                _this.removedPaymentMethodRestrictions = true;
            }
            else {
                _this.recover_insurance = null;
                _this.removedPaymentMethodRestrictions = false;
            }
            _this.updateData({ removedPaymentMethodRestrictions: _this.removedPaymentMethodRestrictions });
        });
        this.userInfo$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (values) {
            _this.userInfo = values;
            _this.updateData({ userInfo: _this.userInfo });
        });
        this.isMobile$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.isMobile = value;
            _this.updateData({ isMobile: _this.isMobile });
        });
        this.okToDelete$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.okToDelete = value;
                _this.updateData({ okToDelete: _this.okToDelete });
            }
        });
    };
    INDRAPaymentAdyenModalComponent.prototype.INDRA_close = function () {
        this.closeModal();
    };
    INDRAPaymentAdyenModalComponent.prototype.onLoad = function () {
        var iframe = document.getElementById('adyen-iframe');
        this.loaded = true;
        var paymentData = Object.assign(this.data[0], {
            hasPaymentMethodRestrictions: this.hasPaymentMethodRestrictions,
            removedPaymentMethodRestrictions: this.removedPaymentMethodRestrictions,
            hasPartnerHotelExtra: this.hasPartnerHotelExtra,
            bookAwardFlights: this.bookAwardFlights,
            userInfo: this.userInfo,
            isMobile: this.isMobile,
            okToDelete: this.okToDelete,
            sessionStorageInfo: {
                language: sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE),
                market: sessionStorage.getItem(SESSION_VAR_KEY_MARKET),
                currency: sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY),
                decimals: sessionStorage.getItem('decimals'),
                token: sessionStorage.getItem(SESSION_VAR_KEY_SESSION),
                lastname: sessionStorage.getItem(SESSION_VAR_KEY_LASTNAME),
                userData: sessionStorage.getItem(SESSION_VAR_KEY_USER_DATA)
            },
            type: 'ibetpfront'
        });
        iframe.contentWindow.postMessage(paymentData, '*');
        this.showLoading = false;
    };
    INDRAPaymentAdyenModalComponent.prototype.updateData = function (data) {
        data.type = 'ibetpfront';
        if (this.loaded) {
            var iframe = document.getElementById('adyen-iframe');
            iframe.contentWindow.postMessage(data, '*');
        }
    };
    INDRAPaymentAdyenModalComponent.prototype.ngAfterContentChecked = function () {
        this.cdr.detectChanges();
    };
    INDRAPaymentAdyenModalComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    return INDRAPaymentAdyenModalComponent;
}(AbstractModalContentComponent));
export { INDRAPaymentAdyenModalComponent };
